import type { ReactElement } from 'react';

import Info from '@/assets/information-alt-icon.svg?react';
import {
  AlertDialogActions,
  AlertDialogCancel,
  AlertDialogDescription,
  AlertDialogTitle,
  Button,
} from '@/components';
import { logEvent } from '@/features/analytics';

export function OptOutContent({
  status,
  onClick,
  isLoading = false,
}: {
  status: string | null;
  onClick?: () => void;
  isLoading?: boolean;
}): ReactElement {
  return (
    <>
      <AlertDialogTitle>
        {status !== 'pending' && status !== 'confirmed' && <Info />}Data Sharing
      </AlertDialogTitle>

      <AlertDialogDescription>
        {status === 'pending' || status === 'confirmed'
          ? 'Your request has been submitted successfully. A confirmation email has been sent to you. It will be processed within 15 business days.'
          : ' By confirming, you request to opt out of sharing your personal data for marketing and ad analytics purposes, which is your “Do Not Share My Personal Information” right under the CCPA/CPRA.'}
      </AlertDialogDescription>

      <AlertDialogActions>
        {status !== 'pending' && status !== 'confirmed' && (
          <AlertDialogCancel asChild>
            <Button
              size="large"
              type="button"
              variant="secondary"
              onClick={() => {
                logEvent('btn_delete_cancel');
              }}
            >
              Cancel
            </Button>
          </AlertDialogCancel>
        )}

        <Button
          size="large"
          type="submit"
          variant="primary"
          disabled={isLoading}
          onClick={() => {
            onClick?.();
          }}
        >
          {isLoading ? 'Processing...' : 'Done'}
        </Button>
      </AlertDialogActions>
    </>
  );
}
